import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Spinner } from 'react-bootstrap';

interface Props {
  title?: string;
  backdrop?: boolean | 'static';
  backdropClassName?: string;
  contentClassName?: string;
  scrollable?: boolean;
  body?: any | string;
  cancelButtonText?: string;
  cancelButtonColor?: string;
  hideCancelButton?: boolean;
  hideConfirmButton?: boolean;
  confirmButtonText?: string;
  confirmButtonColor?: string;
  onConfirm?: () => void;
  show: boolean;
  closeModal: () => void;
  size?: 'sm' | 'lg' | 'xl';
  children?: React.ReactNode;
  onCloseModal?: () => void;
  keyboard?: boolean;
  loading?: boolean;
  errorMessage?: string;
  centered?: boolean;
  animation?: boolean;
  isLackOfInfo?: boolean;
  lackOfInfoMessage?: string;
  noheader?: boolean;
  disabled?: boolean;
  bodyClassName?: string;
  leftButtonSlot?: React.ReactNode;
  bodyStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  hideHeaderCloseButton?: boolean;
  footerClass?: string;
  nofooter?: boolean;
  disableConfirm?: boolean;
  aboveButtonsSlot?: React.ReactNode;
}

const ModalComponent: React.FC<Props> = ({
  noheader = false,
  nofooter = false,
  title,
  backdrop = true,
  backdropClassName = '',
  contentClassName = '',
  scrollable = false,
  body,
  cancelButtonText = 'キャンセル',
  cancelButtonColor = 'secondary',
  hideCancelButton = false,
  hideConfirmButton = false,
  confirmButtonText,
  confirmButtonColor = 'primary',
  onConfirm,
  show,
  closeModal,
  keyboard = true,
  size,
  children,
  onCloseModal = () => { },
  loading = false,
  errorMessage = '',
  centered = false,
  animation = true,
  isLackOfInfo = false,
  lackOfInfoMessage = '',
  disabled = false,
  bodyClassName = '',
  leftButtonSlot = null,
  bodyStyle,
  style,
  hideHeaderCloseButton = false,
  footerClass = 'd-flex justify-content-between',
  disableConfirm = false,
  aboveButtonsSlot = null,
}) => {
  const handleClose = () => {
    closeModal();
    onCloseModal();
  };
  const handleConfirm = () => {
    if (typeof (onConfirm) === 'function') {
      onConfirm();
    }
  };

  return (
    <Modal
      backdrop={backdrop}
      backdropClassName={backdropClassName}
      contentClassName={contentClassName}
      size={size}
      show={show}
      onHide={handleClose}
      centered={centered}
      animation={animation}
      keyboard={keyboard}
      scrollable={scrollable}
      style={style}
    >
      {!noheader && (
        <Modal.Header closeButton={!hideHeaderCloseButton}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body className={bodyClassName} style={bodyStyle}>
        <div className="text-danger">
          {errorMessage}
        </div>
        {body}
        {children}
      </Modal.Body>

      {!nofooter && (
        <Modal.Footer className="d-flex flex-column">
          {aboveButtonsSlot && (
            <div className="w-100" style={{ marginBottom: '12px' }}>
              {aboveButtonsSlot}
            </div>
          )}
          <div className={footerClass} style={{ width: '100%' }}>
            <div>
              {leftButtonSlot}
            </div>
            <div className="d-flex align-items-center">
              {isLackOfInfo && <p className="link-danger me-1">{lackOfInfoMessage ?? '必須入力項目を入力してください'}</p>}
              <div style={{ display: 'flex', gap: '5px', flexShrink: 0 }}>
                {!hideCancelButton && (
                  <Button disabled={loading} variant={cancelButtonColor} onClick={handleClose}>
                    {cancelButtonText}
                  </Button>
                )}
                {!hideConfirmButton && (
                  <Button style={{ marginLeft: '7px' }} disabled={loading || isLackOfInfo || disabled || disableConfirm} variant={confirmButtonColor} onClick={handleConfirm}>
                    {confirmButtonText}
                    {' '}
                    {loading ? <Spinner animation="border" size="sm" /> : ''}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default ModalComponent;
